import { render } from "./SocialLoginRegistration.vue?vue&type=template&id=5a273314"
import script from "./SocialLoginRegistration.vue?vue&type=script&lang=js"
export * from "./SocialLoginRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__